export default __webpack_public_path__ + "static/media/move-547383__diakunik__wood-dropping.8867ccc3.mp3";